import axios from 'axios';

const whatsappApi = axios.create({
  baseURL: process.env.REACT_APP_WHATSAPP_API_URL, 
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${process.env.REACT_APP_WHATSAPP_ACCESS_TOKEN}`, 
  },
});

const getWhatsAppTemplateName = (isPositive) => {
  switch (process.env.REACT_APP_ENV) {
    case 'production':
      return isPositive ? 'retorno_positivo_prd' : 'retorno_negativo_prd';
    default:
      return isPositive ? 'retorno_positivo_stg' : 'retorno_negativo_stg';
  }
};

export const sendWhatsAppMessage = async ({ phoneNumber, userName, isPositive }) => {
  const templateName = getWhatsAppTemplateName(isPositive);
  const payload = {
    messaging_product: 'whatsapp',
    to: phoneNumber,
    type: 'template',
    template: {
      name: templateName, 
      language: { code: 'pt_BR' },
      components: [
        {
          type: 'body',
          parameters: [
            { type: 'text', text: userName }
          ],
        },
      ],
    },
  };

  try {
    const response = await whatsappApi.post('', payload);
    return response.data;
  } catch (error) {
    console.error(`Erro ao enviar mensagem ${isPositive ? 'positiva' : 'negativa'}:`, error.response?.data || error.message);
    throw new Error(error.response?.data?.error?.message || 'Falha ao enviar mensagem no WhatsApp.');
  }
};
